import { Col, Row } from "react-bootstrap";
import ActiveLicenceDetails from "./ActiveLicenceDetails";
import BreadCrumbs from "./BreadCrumbs";
import Compliance from "./Compliance";
import LicenceProfileHeader from "./LicenceProfileHeader";
import LicenceDetails from "./LicenceDetails";
import LicenceProfileSiteDetails from "./LicenceProfileSiteDetails";
import LicenceProfileSubTabs from "./LicenceProfileSubTabs";
import { useParams } from "react-router-dom";
import Page404 from "../../pages/auth/Page404";

import useAppSelector from "../../hooks/useAppSelector";
import useAppDispatch from "../../hooks/useAppDispatch";
import {
  loadLicenceProfileAsync,
  selectLicenceProfileResponse,
} from "../../redux/slices/licenceProfile";
import UrbanWasteWaterSiteDetails from "./UrbanWasteWaterSiteDetails";
import { useState } from "react";
import {
  GetLicenceProfileNotReadyComponent,
  IsLicenceProfileReady,
} from "../../leap-components/LicenceProfile/LicenceProfileResponseComponentFactory";
import { ILicenceProfile } from "../../api/LicenceProfile";

const LicenceDashboard = () => {
  const [loading, setLoading] = useState(false);
  const licenceProfileSelector = useAppSelector(selectLicenceProfileResponse);
  const dispatch = useAppDispatch();

  let { profileNo } = useParams();
  if (!profileNo) {
    return <Page404 />;
  }

  if (!loading) {
    setLoading(true);
    dispatch(loadLicenceProfileAsync(profileNo));
  }

  if (!IsLicenceProfileReady(licenceProfileSelector.licenceProfileResponse)) {
    return GetLicenceProfileNotReadyComponent(
      licenceProfileSelector.licenceProfileResponse
    );
  }

  const licenceProfile = licenceProfileSelector.licenceProfileResponse
    ?.licenceProfile as ILicenceProfile;

  const isUWW =
    licenceProfile.type === "Waste Water Discharge Authorisation" ||
    licenceProfile.type === "Certificate of Authorisation";

  const contentElement = (
    <div>
      <Row>
        <Col className="col-12 col-sm-12 col-md-4">
          <LicenceDetails licenceProfile={licenceProfile} />
        </Col>
        <Col className="col-12 col-sm-12 col-md-4">
          <ActiveLicenceDetails licenceProfile={licenceProfile} />
        </Col>
        <Col className="col-12 col-sm-12 col-md-4">
          {isUWW && (
            <UrbanWasteWaterSiteDetails
              siteDetails={licenceProfile.siteDetails}
              licenceProfile={licenceProfile}
            />
          )}
          {!isUWW && (
            <LicenceProfileSiteDetails
              siteDetails={licenceProfile.siteDetails}
            />
          )}
        </Col>
      </Row>
      <Row>
        <Col className="col-12">
          <Compliance licenceProfile={licenceProfile} />
        </Col>
      </Row>
    </div>
  );

  return (
    <div>
      <BreadCrumbs licenceProfile={licenceProfile} />
      <div className="ps-0">
        <LicenceProfileHeader licenceProfile={licenceProfile} />
        <LicenceProfileSubTabs
          activeKey="licence-dashboard"
          content={contentElement}
          licenceProfile={licenceProfile}
        />
      </div>
    </div>
  );
};

export default LicenceDashboard;
